import axios from 'axios'
import { isDemoAccess } from '@/helpers/accessOrigin'
import { ROUTES } from '@/types/routes'

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'https://api.fluencyflow.com',
  headers: {
    'Content-Type': 'application/json'
  }
})

// Add request interceptor for auth
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('accessToken')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized
      sessionStorage.removeItem('accessToken')
      window.location.href = isDemoAccess() ? ROUTES.ACCESS_EXPIRED : '/'
    }
    return Promise.reject(error)
  }
)

export default api
